/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { getAsset } from '@msdyn365-commerce/core';

// TODO: Current build require at least one tsx file
export default () => <div />;

export const urlFontFamilyCSM = (request?: any) =>
  getAsset('/webfonts/', request);

// Usage example:
// const fontUrl = urlFontFamilyCSM(props.context.request); // in a component file
// then use fontUrl in a style tag or link tag to load fonts dynamically based on request context (e.g. locale)
